import '.am{flex-shrink:0;}.ssr-plugin'
import '.ao{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.an{height:100%;}.ssr-plugin'
import '.bi{border:none;}.ssr-plugin'
import '.g8{background-color:transparent;}.ssr-plugin'
import '.g9{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ax{position:sticky;}.ssr-plugin'
import '.ga{top:4rem;}.ssr-plugin'
import '.gb{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.gc{padding-bottom:1rem;}.ssr-plugin'
import '.cs{margin-bottom:1rem;}.ssr-plugin'
import '.gd{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.ay{top:0px;}.ssr-plugin'
import '.b5{left:0px;}.ssr-plugin'
import '.b6{right:0px;}.ssr-plugin'
import '.b7{bottom:0px;}.ssr-plugin'
import '.d5{z-index:9999;}.ssr-plugin'
import '.d6{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.av{justify-content:flex-end;}.ssr-plugin'
import '.ap{flex:1;}.ssr-plugin'
import '.bh{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="am ao n an bi g8 g9"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a2"
    >
      <div className="ax ga gb t gc cs gd d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i ay b5 b6 b7 d5 t d6 d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ao d av gd"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ap bh">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
